export const ProjectsData = [
  {
    id: 1,
    name: "Projeto clone tela da Dio em REACT",
    imgUrl: process.env.PUBLIC_URL + "/assets/dio.jpg",
    desc: "Elaborado como parte do Bootcamp Orange Tech+ da DIO.",
    languages: ["React", "TypeScript"],
    github: "https://github.com/Phgodoi/projeto-dio-react"
  },
  {
    id: 2,
    name: "Pokedex usando PokeApi",
    imgUrl: process.env.PUBLIC_URL + "/assets/pokedex.png",
    desc: "Iniciativa criada visando aprimorar a experiência com APIs por meio de um projeto prático.",
    languages: ["JavaScript", "CSS", "HTML"],
    github: "https://github.com/Phgodoi/pokedex"
  },
  {
    id: 3,
    name: "Tela de login com validação de credenciais",
    imgUrl: process.env.PUBLIC_URL + "/assets/validacaoLogin.png",
    desc: "Elaboração de um formulário de login e registro de contas com verificação de credenciais.",
    languages: ["TypeScript", "React"],
    github: "https://github.com/Phgodoi/validacao-login-dio"
  },
  {
    id: 4,
    name: "Tela de login",
    imgUrl: process.env.PUBLIC_URL + "/assets/telaLogin.png",
    desc: "Desenvolvimento de uma interface de login com atualização automática de imagens",
    languages: ["JavaScript", "CSS", "HTML"],
    github: "https://github.com/Phgodoi/telaLogin"
  },
  {
    id: 5,
    name: "Origem do Android",
    imgUrl: process.env.PUBLIC_URL + "/assets/origenAndroid.png",
    desc: "Página desenvolvida como parte do desafio do curso em vídeo, com o propósito de narrar a história da origem do Android.",
    languages: ["CSS", "HTML"],
    github: "https://github.com/Phgodoi/origemAndroid"
  },
  {
    id: 6,
    name: "Calculadora React",
    imgUrl: process.env.PUBLIC_URL + "/assets/calculadora.png",
    desc: "Projeto desenvolvido como parte do Bootcamp Orange Tech+ da DIO. Com o objetivo de aprimorar meus conhecimentos em React.",
    languages: ["Javascript","React", "HTML"],
    github: "https://github.com/Phgodoi/calculadora-react"
  },
  
];
